import { Col, Form } from 'react-bootstrap';
import Select from 'react-select';

/**
 * Selector de la sucursal desde la que se emite el documento.
 *
 * Se muestra dentro de la sección "Datos del Emisor" de las vistas de emisión web
 * y se comporta según cuántas sucursales tenga cargadas el emisor:
 *  - ninguna: no se muestra, la emisión funciona con la dirección de la empresa.
 *  - una: se muestra solo como dato, no hay nada que elegir.
 *  - dos o más: parte en la casa matriz; si ninguna lo es, hay que elegir.
 */
function SelectorSucursal({ sucursales, sucursalId, onChange, cargando, md = 4 }) {
  if (cargando) {
    return (
      <Col md={md}>
        <Form.Label>Sucursal</Form.Label>
        <Form.Control type="text" value="Cargando sucursales…" readOnly />
      </Col>
    );
  }

  if (sucursales.length === 0) return null;

  const ayuda = (
    <Form.Text className="text-muted">
      La dirección impresa en el documento es la de esta sucursal.
    </Form.Text>
  );

  if (sucursales.length === 1) {
    return (
      <Col md={md}>
        <Form.Label>Sucursal</Form.Label>
        <Form.Control type="text" value={sucursales[0].nombre} readOnly />
        {ayuda}
      </Col>
    );
  }

  const opciones = sucursales.map((s) => ({ value: String(s.sucursal_id), label: s.nombre }));

  return (
    <Col md={md}>
      <Form.Label>Sucursal</Form.Label>
      <Select
        options={opciones}
        value={opciones.find((o) => o.value === String(sucursalId)) || null}
        onChange={(opt) => onChange(opt ? opt.value : '')}
        placeholder="Selecciona la sucursal"
        isSearchable={false}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
      {sucursalId ? ayuda : (
        <Form.Text className="text-danger">
          Debes elegir desde qué sucursal se emite el documento.
        </Form.Text>
      )}
    </Col>
  );
}

export default SelectorSucursal;
